var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-banner'),_c('div',{staticClass:"iot-bg"},[_c('recommend'),_c('product')],1),_c('shop'),_c('result'),_c('policy'),_c('consult'),_c('home-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }